import React, { useState } from "react";
import axios from "axios";
import GrievanceForm from "../components/GrievanceForm";
import "./Home.css";

function Home() {
  const [trackId, setTrackId] = useState("");
  const [trackResult, setTrackResult] = useState(null);
  const [trackError, setTrackError] = useState("");
  const [isTracking, setIsTracking] = useState(false);

  const handleTrack = async () => {
    if (!trackId.trim()) {
      setTrackError("Please enter a valid Grievance Number.");
      return;
    }

    setIsTracking(true);
    setTrackError("");
    setTrackResult(null);

    try {
      const res = await axios.get(
        `https://grs.jeccac.in/api/grievance/status/${trackId.trim()}`
      );
      setTrackResult(res.data);
    } catch (err) {
      setTrackError("Grievance not found. Please verify the ID and try again.");
    } finally {
      setIsTracking(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Pending":
        return "#f39c12"; // Orange
      case "In Review":
        return "#3498db"; // Blue
      case "Resolved":
        return "#2ecc71"; // Green
      case "Closed":
        return "#95a5a6"; // Gray
      default:
        return "#333";
    }
  };

  return (
    <div className="home-container">
      {/* Decorative Background Blob */}
      <div className="bg-shape"></div>

      <div className="home-content">
        {/* LEFT SECTION */}
        <div className="left-panel">
          <div className="brand-header">
            <h1 className="college-title">Jyothi Engineering College</h1>
            <h2 className="system-subtitle">Grievance Redressal System</h2>
          </div>

          <p className="description">
            We are committed to providing a safe, transparent, and responsive
            environment. Submit your grievance securely online. A unique
            grievance number will be generated and instantly sent to your
            registered email for continuous tracking.
          </p>

          <div className="btn-group">
            <button className="nav-btn primary-nav-btn">
              Grievance Committee
            </button>
            <a
              href="https://www.jecc.ac.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-btn secondary-nav-btn"
            >
              College Website
            </a>
          </div>

          <div className="track-card">
            <h3>Track Grievance Status</h3>
            <p className="track-desc">
              Enter your grievance ID to check its current progress.
            </p>
            <div className="track-input-group">
              <input
                type="text"
                placeholder="e.g. JEC-GRS-123456789"
                value={trackId}
                onChange={(e) => setTrackId(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleTrack()}
              />
              <button
                className="track-btn"
                onClick={handleTrack}
                disabled={isTracking}
              >
                {isTracking ? "Searching..." : "Track"}
              </button>
            </div>

            {/* Tracking Results Area */}
            {trackError && <div className="track-error">{trackError}</div>}
            {trackResult && (
              <div className="track-result-box">
                <div className="track-row">
                  <span className="track-label">Name:</span>
                  <span className="track-value">{trackResult.name}</span>
                </div>
                <div className="track-row">
                  <span className="track-label">Category:</span>
                  <span className="track-value">{trackResult.category}</span>
                </div>
                <div className="track-row">
                  <span className="track-label">Type:</span>
                  <span className="track-value">
                    {trackResult.grievanceType}
                  </span>
                </div>
                <div
                  className="track-row status-row"
                  style={{ borderColor: getStatusColor(trackResult.status) }}
                >
                  <span
                    className="track-label"
                    style={{ color: getStatusColor(trackResult.status) }}
                  >
                    Current Status:
                  </span>
                  <span
                    className="track-value status-badge"
                    style={{
                      backgroundColor: getStatusColor(trackResult.status),
                    }}
                  >
                    {trackResult.status}
                  </span>
                </div>
                {trackResult.adminReply && (
                  <div className="track-reply-box">
                    <strong>Admin Reply:</strong>
                    <p>{trackResult.adminReply}</p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* RIGHT SECTION: The Form */}
        <div className="right-panel">
          <div className="form-wrapper-card">
            <GrievanceForm />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
